/**
 * Thinkboard's build-time switch. Read like services/apiConfig.ts reads its
 * values: through `?.`, because under Jest `import.meta` carries no `env`.
 * Off (the default, and production until it is switched on there) hides the
 * nav entry and the routes; the server's THINKBOARD_ENABLED refuses the API.
 */
const env = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;

export const THINKBOARD_ENABLED = env?.VITE_THINKBOARD_ENABLED === "true";
